// extracted by mini-css-extract-plugin
export default {"wrapper":"SidebarLayout_wrapper__yJ9+0","main":"SidebarLayout_main__jjhQy","wrapperPhone":"SidebarLayout_wrapperPhone__w1CMc"};